import { isApiValidationError } from '@/core/api/response-handler';

/**
 * Cine are voie sa mai scoata un mesaj generic la o trimitere esuata (SP-05a, valul (d), R1).
 *
 * 🔴 Problema masurata de S1 pe `51baf56d`, la 400: omul primeste DOUA mesaje deodata —
 * eroarea buna langa camp, care numeste fragmentul («Nu am înțeles „a V-a Q".»), SI un toast
 * rosu cu textul brut al serverului («Clase neintelese»), fara diacritice. Adica exact forma
 * pe care directia a refuzat-o la #113, lipita de cea care a inlocuit-o. Reparatia de la #113
 * era livrata pe jumatate.
 *
 * ⚠️ **Nu se scoate toastul generic pentru toata lumea** — constrangerea e a lui S1 si e
 * corecta: pentru un 400 fara fragmente, un 500, sau o cadere de retea, toastul e SINGURUL
 * mesaj pe care il primeste omul. Scos de tot, o trimitere esuata ar arata identic cu una care
 * n-a plecat inca.
 *
 * Deci decizia e ingusta: taci **numai** cand eroarea poarta deja fragmentele care se
 * afiseaza langa camp. Un singur consumator produce azi fragmente (`POST /api/answers` cu
 * `clase`, campul `fragmenteNerecunoscute`), si acolo `use-lesson-completion` le pune pe ecran
 * in acelasi `catch`.
 *
 * 🔴 De ce e modul pur, si nu un `if` in hook: `vitest.config.ts` ruleaza pe
 * `environment: 'node'`, fara jsdom, deci un test de componenta nu se poate scrie. Decizia
 * scoasa aici e singura parte a lui R1 care poate avea poarta automata; restul se masoara cu
 * ochii pe ecran.
 */
export function fragmenteAfisateLangaCamp(error: unknown): string[] {
    if (!isApiValidationError(error)) return [];
    const fragmente = error.fragmenteNerecunoscute;
    // Forma se reverifica aici, desi `handleResponse` a verificat-o deja la granita: modulul
    // asta primeste `unknown` si nu are voie sa presupuna de unde vine eroarea.
    if (!Array.isArray(fragmente)) return [];
    return fragmente.filter((f): f is string => typeof f === 'string' && f.trim() !== '');
}

/**
 * Se mai afiseaza toastul generic de eroare pentru eroarea asta?
 *
 * `false` doar cand eroarea poarta fragmente afisabile — atunci mesajul de langa camp spune
 * mai mult si mai bine. In orice alt caz `true`, inclusiv pentru erorile care nu vin de la
 * backend.
 */
export function trebuieToastGeneric(error: unknown): boolean {
    return fragmenteAfisateLangaCamp(error).length === 0;
}
